<ng-template #alertHost></ng-template>

<div class="fd p_20 mobile-mode-margin">
  <footer class="footer">

    <!-- TOP SECTION -->
    <div class="footer-top container">
      <div class="row">

        <!-- Payment Methods -->
        <div class="col-md-6 payment-section">
          <h6 class="headfooter">{{'Payment Methods' | translate }}</h6>
          <div class="icons">
            <img  alt="bkash P2p" loading="lazy" decoding="async"
              src="https://dazen1.one/form/logo/bkash_p2p_74e5df7387da4948a6bda46f4a2e81e4.svg" />
            <img  alt="bkash" loading="lazy" decoding="async"
              src="https://img.d4040p.com/dp/h5/assets/images/footer/color-black/pay22.png?v=1776751585638&source=mcdsrc" />
            <img alt="nagini" loading="lazy" decoding="async"
              src="https://img.d4040p.com/dp/h5/assets/images/footer/color-black/pay34.png?v=1776751585638&source=mcdsrc" />
          </div>
        </div>

        <!-- Community -->
        <div class="col-md-6 community-section text-md-end">
          <h6 class="headfooter">{{'Community Websites' | translate}}</h6>
          <div class="social-icons">

            <img src="../../../assets/siteImg/social_logo/facebook.png" alt="facebook" loading="lazy" decoding="async"
              (click)="openwindow('https://www.facebook.com/share/1ANNfLtCQS/')">
            <img src="../../../assets/siteImg/social_logo/telegram.png" alt="telegram" loading="lazy" decoding="async"
              (click)="openwindow('http://t.me/Gambajiofficial')">
            <img src="../../../assets/siteImg/social_logo/whatsapp.png" alt="whatsapp" loading="lazy" decoding="async" 
                (click)="openwindow('https://wa.me/message/6WPI5NGU5VDCJ1')">
            <img src="../../../assets/siteImg/social_logo/twitter.png" alt="twitter" loading="lazy" decoding="async"
              (click)="openwindow('https://x.com/gembajiteam')">
            <img src="../../../assets/siteImg/social_logo/instagram.png" alt="instagram" loading="lazy" decoding="async"
              (click)="openwindow('https://www.instagram.com/gembajiofficial?igsh=MWp5cnk0Y3ZscHFiOQ==')">
          </div>
        </div>

      </div>

      <!-- Partner -->
      <!-- <div class="partner mt-5">
        <h6 class="headfooter">{{'Official Partner' | translate}}</h6>
        <img src="https://img.d4040p.com/dp/h5/assets/images/footer/color-black/official-partner-heyvip.png?v=1776751585638&source=mcdsrc" class="partner-logo" />
      </div> -->
    </div>

    <!-- MENU LINKS -->
    <div class="footer-links">
      <div class="container links-wrapper">
        <a href="#">{{'ABOUT_US' | translate}}</a>
        <a href="#">{{'CONTACT_US' | translate}}</a>
        <a routerLink="/privacypolicy">{{'_PRIVACY_POLICY' | translate}}</a>
        <a routerLink="/terms-and-conditions">{{'TERMS_&_CONDITIONS' | translate}}</a>
        <a href="#">{{'Rules and Regulations' | translate}}</a>
        <a href="#">{{'Responsible Gaming' | translate}}</a>
        <a href="#">{{'Frequently Asked Questions' | translate}}</a>
        <a href="/affiliate" target="_blank">{{'Affiliate' | translate}}</a>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="footer-content container">
      <h4>{{ 'FooterSiteHead' | translate}}</h4>
      <p>
        {{ 'FooterSite_msg' | translate}}
      </p>

      <h6>{{'Our Story' | translate}}</h6>

     <ul [class.open]="ReadMorestatus" class="readmore-container">
  <li *ngFor="let item of websitefooterdespn">
    <h6>{{item.headText | translate}}</h6>
      <p>{{item.para | translate}}</p>
  </li>
</ul>

<button class="read-more" (click)="Readmoresection()">
  {{ ReadMorestatus ? ('Read Less' | translate) : ('Read More' | translate) }}
  <i class="fa" [ngClass]="ReadMorestatus ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
</button>

    </div>

    <!-- BOTTOM -->
    <div class="footer-bottom container">
      <div class="logo">
        <img src="../../../assets/siteImg/Gambaji.svg"  alt="logo" loading="lazy" decoding="async"/>
      </div>
      <p>{{'All Rights Reserved' | translate}}</p>
    </div>

  </footer>
</div>